/**
 * Lightbox
 */

"use strict";


export class Lightbox {
  /**
   * Constructor 
   */
  constructor() {
    this.init();
  }

  /**
   * Init
   */
  init() {
    window.addEventListener('load', () => {
      const iframeContainer = document.createElement('div');
      iframeContainer.classList.add('lightbox', 'hidden');
      document.body.appendChild(iframeContainer);

      const exitButton = document.createElement('div');
      exitButton.classList.add('lightbox-exit');
      iframeContainer.appendChild(exitButton);

      const iframe = document.createElement('iframe');
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.allowFullscreen = true;
      iframeContainer.appendChild(iframe);

      const els = document.querySelectorAll('[data-lightbox]');

      els.forEach((el) => {
        if( ! el.dataset.url && ! el.dataset.title ) return;

        this._add_item_click_listener(el, iframeContainer, iframe);
      })

      this._exit_events(iframeContainer);
    });
  }

  /**
   * _exit_event
   *
   * @param {HTMLElement} container
   */
  _exit_events(container) {
    container.addEventListener('click', () => {
      container.classList.add('hidden');
    });

    document.addEventListener('keydown', (event) => {
      if( event.key === "Escape" ) {
        container.classList.add('hidden');
      }
    });
  }

  /**
   * _add_item_click_listener
   *
   * @param {HTMLElement} item
   */
  _add_item_click_listener(el, container, iframe) {
    el.addEventListener('click', () => {
      iframe.src = el.dataset.url; 
      iframe.title = el.dataset.title; 

      if( container.classList.contains('hidden') ) {
        container.classList.remove('hidden');
      }
      else {
        container.classList.add('hidden');
      }
    });
  }
}
